var link_viewer_default = {
  "fontElementMap": "fTmXw",
  "link": "ajoa9",
  "linkInEditor": "xjZ82",
  "linkInViewer": "viUIj",
  "toolbarUrlContainer": "oos2x",
  "toolbarUrl": "kKx-S",
  "toolbarUrlAnchor": "irOu-"
};
export {
  link_viewer_default as default
};
//# sourceMappingURL=link-viewer-scss.js.map
